import React, { Component } from 'react';
import Hero from "./../../alpineComponents/hero";
import CollectionBrowser from "./../../components/collectionBrowser";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class Stories extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'The Joys of Jet Lag | Excerpts'}</title>
          <meta name="description" content="Get a sneak peak of some of the chapters in Kat Medina's first book, The Joys of Jet Lag." />
        </Helmet>
        <BannerFadeIn>
          <CollectionBrowser mobileOptimize />
        </BannerFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/stories/index.js